// docs/87: a key hint that follows the player's rebinds (nothing when the hotkey is unbound).
import { useKeyLabel } from '../../core/input/hotkeys';
import { Kbd } from './Badge';

export function HotkeyKbd({ id }: { id: string }) {
  const k = useKeyLabel(id);
  return k ? <Kbd>{k}</Kbd> : null;
}
